function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "account_box");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Two-Tone",
  transform: "translate(-715.000000, -157.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Action",
  transform: "translate(100.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Two-Tone-/-Action-/-account_box",
  transform: "translate(612.000000, 54.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5,19 L19,19 L19,5 L5,5 L5,19 Z M12,6 C13.65,6 15,7.35 15,9 C15,10.65 13.65,12 12,12 C10.35,12 9,10.65 9,9 C9,7.35 10.35,6 12,6 Z M6,16.47 C6,13.97 9.97,12.89 12,12.89 C14.03,12.89 18,13.97 18,16.47 L18,18 L6,18 L6,16.47 Z",
  id: "Secondary-Color",
  fill: "#D0D0D0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,12 C13.65,12 15,10.65 15,9 C15,7.35 13.65,6 12,6 C10.35,6 9,7.35 9,9 C9,10.65 10.35,12 12,12 Z M12,8 C12.55,8 13,8.45 13,9 C13,9.55 12.55,10 12,10 C11.45,10 11,9.55 11,9 C11,8.45 11.45,8 12,8 Z M19,3 L5,3 C3.89,3 3,3.9 3,5 L3,19 C3,20.1 3.89,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z M19,19 L5,19 L5,5 L19,5 L19,19 Z M18,16.47 C18,13.97 14.03,12.89 12,12.89 C9.97,12.89 6,13.97 6,16.47 L6,18 L18,18 L18,16.47 Z M8.31,16 C9,15.44 10.69,14.88 12,14.88 C13.31,14.88 15.01,15.44 15.69,16 L8.31,16 Z",
  id: "Primary-Color",
  fill: "#1D1D1D"
}))))));

var SvgAccountBox = function SvgAccountBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccountBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account_box.8b555224.svg";
export { ForwardRef as ReactComponent };